/** F606 Challenges page — community challenges. */
import { Trophy } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606ChallengesPage() {
  return (
    <F606DataPage
      entity="challenges"
      titleAr="التحديات"
      titleEn="Challenges"
      icon={Trophy}
      emptyIcon={Trophy}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'title',
          ar: 'التحدي', en: 'Challenge',
          render: (r) => (
            <div>
              <div className="font-bold text-white">{r.title || r.name || '—'}</div>
              {r.type && <div className="text-[10px] text-white/40">{r.type}</div>}
            </div>
          ),
        },
        { key: 'participants', ar: 'المشاركون', en: 'Participants', render: (r) => r.participants_count ?? r.entrants ?? '—', className: 'w-24 text-center' },
        {
          key: 'start_date',
          ar: 'يبدأ', en: 'Start',
          render: (r) => r.start_date || r.starts_at ? new Date(r.start_date || r.starts_at).toLocaleDateString() : '—',
          className: 'w-28 text-[11px] text-white/60',
        },
        {
          key: 'end_date',
          ar: 'ينتهي', en: 'End',
          render: (r) => r.end_date || r.ends_at ? new Date(r.end_date || r.ends_at).toLocaleDateString() : '—',
          className: 'w-28 text-[11px] text-white/60',
        },
        {
          key: 'status',
          ar: 'الحالة', en: 'Status',
          render: (r) => {
            const s = String(r.status || '').toLowerCase();
            const isActive = s === 'active' || s === 'open';
            return (
              <span className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-bold border ${
                isActive ? 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300' : 'bg-white/5 border-white/10 text-white/50'
              }`}>
                {r.status || '—'}
              </span>
            );
          },
          className: 'w-24',
        },
      ]}
    />
  );
}
